export function isDateString(str: string) {
  const date = new Date(str);
  return date.toString() !== "Invalid Date";
}

export function sort<T>(items: T[], selector: (item: T) => any, asc: boolean = true): T[] {
  return [...items].sort((a, b) => {
    a = selector(a);
    b = selector(b);
    const mul = asc ? 1 : -1;

    if (typeof a === "number" && typeof b === "number") {
      return (a - b) * mul;
    }
    if (typeof a === "string" && typeof b === "string") {
      if (isDateString(a)) return (new Date(a).getTime() - new Date(b).getTime()) * mul;
      if (!a) return 1 * mul;
      if (!b) return -1 * mul;
      return a.localeCompare(b) * mul;
    }
    if (a instanceof Date && b instanceof Date) {
      return (a.getTime() - b.getTime()) * mul;
    }
    if (typeof a === "boolean" && typeof b === "boolean") {
      if (a) return -1 * mul;
      return 1 * mul;
    }
    return 0;
  });
}
